module.exports = __webpack_public_path__ + "static/img/Bachelor_010369.673547a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010369.jpg
// module id = 157
// module chunks = 0